import React, { Suspense } from "react";
import { Link } from "react-router-dom";
import ShowAllIPC from "./ShowAllIPC";
import "../events/events-responsive.css";

const AllIPCostingPage = () => {
  return (
    <>
      <Suspense fallback={<>Loading...</>}>
        <div className="main_container cost-sheet-wrapper px-5">
          {/* <Sidebar />
          <Navbar /> */}
          <div className="right_col" role="main">
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="x_panel">
                  <div className="x_title">
                    <div className="clearfix">
                      <Link to="/addipcosting">
                          <button className="btn btn-primary btn-sm">
                            Add Cost Sheet(s) <i className="fa fa-plus"></i>
                          </button>
                        </Link>
                      <div className="x_content">
                        <ShowAllIPC />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <Footer /> */}
        </div>
      </Suspense>
    </>
  );
};
export default AllIPCostingPage;
